import { createApp, reactive } from 'vue';
import App from './App.vue';
import '../public/chart.css';
import router from './router';
import axios from 'axios';
import qs from 'qs';
import { Toast, Loading, Swipe, SwipeItem, ImagePreview } from 'vant';
import 'vant/lib/index.css';
import provideUserManager from './oidc.js';

// 定义全局接口地址
const apiUrl = 'https://api.baogaoting.com';
// const apiUrl = 'http://192.168.2.146:83';

// 百度统计
router.afterEach(() => {
    setTimeout(() => {
        var _hmt = _hmt || [];
        (function() {
            //每次执行前，先移除上次插入的代码
            document.getElementById('baidu_count') && document.getElementById('baidu_count').remove();
            var hm = document.createElement("script");
            hm.src = "https://hm.baidu.com/hm.js?78c6d6f014bad796b6b541a508d78f09";
            hm.id = "baidu_count"
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
        })();
    }, 0);
});

// 判断设备类型
const isMobile = window.innerWidth <= 768 || /Mobile/i.test(navigator.userAgent);
const globalState = reactive({
    isMobile: isMobile,
    apiUrl: apiUrl,
});
const userManager = provideUserManager();

const request = axios.create({
    baseURL: apiUrl,
    timeout: 180000, // 3分钟超时时间
})

//判断浏览器是否支持webp格式图片
function checkWebpFeature(feature, callback) {
    let kTestImages = { //lossy:“有损”,lossless:“无损”,alpha:“α”或animation:“动画”。
        lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
        lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
        alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
        animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
    };
    let img = new Image();
    img.onload = function() {
        let result = (img.width > 0) && (img.height > 0);
        callback(feature, result);
    };
    img.onerror = function() {
        callback(feature, false);
    };
    img.src = "data:image/webp;base64," + kTestImages[feature];
}
let webpImg = '';
checkWebpFeature('lossless', function(feature, result) {
    if (result == true) {
        webpImg = ',image/webp';
    }
});

// 请求拦截
userManager.getUser().then(function(user) {
    if (user) {
        // 判断 token 是否过期
        var timestamp = Math.round(new Date().getTime() / 1000).toString();
        if (user.expires_at < timestamp) {
            // 清除 token 和用户信息
            userManager.removeUser();
            // token 已过期跳转到登录页
            router.push('/login');
        } else {
            // token 未过期，设置请求头的 Authorization 字段
            request.interceptors.request.use(
                config => {
                    config.headers.Authorization = "Bearer " + user.access_token;
                    return config;
                },
                error => {
                    return Promise.reject(error);
                }
            );
        }
    }
});

// 响应拦截
request.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        console.log(error)
        if (error.response.status == 401) {
            // localStorage.removeItem('referrer');
            // token 已过期跳转到登录页
            router.push('/login');
        }
        return Promise.reject(error);
    }
);
// 封装get请求
export function get(url, params, config = {}) {
    return new Promise((resolve, reject) => {
        request.get(url, {...config, params, headers: { 'accept': 'application/json, text/plain, */*' + webpImg }, })
            .then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err.data)
            })
    })
}

// 封装post请求
export function post(url, params, config = {}) {
    return new Promise((resolve, reject) => {
        request.post(url, qs.stringify(params), config)
            .then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err.data)
            })
    })
}
export function post2(url, params) {
    return new Promise((resolve, reject) => {
        request.post(url, params, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(res => {
                resolve(res.data);
            }).catch(err => {
                reject(err.data)
            })
    })
}

var app = createApp(App);
app.use(router);
app.use(Toast);
app.use(Loading);
app.use(Swipe);
app.use(SwipeItem);
app.use(ImagePreview);
app.provide('globalState', globalState);
app.provide('userManager', userManager);
app.mount('#app');